import Head from 'components/Head'
import Banner from 'components/pages/CasaVerdeAmarela/Banner'
import Descricao from 'components/pages/CasaVerdeAmarela/Descricao'
import Vantagens from 'components/pages/CasaVerdeAmarela/Vantagens'
import QuemPode from 'components/pages/CasaVerdeAmarela/QuemPode'
import Porque from 'components/pages/CasaVerdeAmarela/Porque'
import Passos from 'components/pages/CasaVerdeAmarela/Passos'
import Duvidas from 'components/pages/CasaVerdeAmarela/Duvidas'
import ReceiveNews from 'components/ReceiveNews'


export default function Realiza({ data }) {
  return (
    <>
      <Head data={data.seo} />
      <Banner data={data.banner} />
       <Descricao data={data.descricao} />
      <Vantagens data={data.vantagens} />
      <QuemPode data={data.quem_pode} />
      <Passos data={data.passos}/>
      <Porque data={data.porque} />
      <Duvidas data={data.duvidas}/>
      <ReceiveNews data={data.secaoRecebaNovidades}/>
    </>
  )
}